import KanbanPipelineList from './KanbanPipelineList.vue';
import KanbanPipelinesPage from './KanbanPipelinesPage.vue';
import KanbanView from './KanbanView.vue';
import KanbanRouter from './KanbanRouter.vue';

export default [
  {
    path: '/app/accounts/:accountId/kanban',
    name: 'kanban_index',
    component: KanbanPipelineList,
    meta: {
      requiresAuth: true,
      layout: 'dashboard',
   //   permissions: ['administrator', 'agent'],
    },
  },
  {
    path: '/app/accounts/:accountId/kanban/pipelines',
    name: 'kanban_pipelines_index',
    component: KanbanPipelinesPage,
    meta: {
      requiresAuth: true,
      layout: 'dashboard',
  //    permissions: ['administrator', 'agent'],
    },
  },
  {
    path: '/app/accounts/:accountId/kanban/board',
    name: 'kanban_board_index',
    component: KanbanRouter,
    meta: {
      requiresAuth: true,
      layout: 'dashboard',
  //    permissions: ['administrator', 'agent'],
    },
  },
  {
    path: '/app/accounts/:accountId/kanban/board/:pipelineId',
    name: 'kanban_pipeline_board',
    component: KanbanRouter,
    meta: {
      requiresAuth: true,
      layout: 'dashboard',
   //   permissions: ['administrator', 'agent'],
    },
  },
];
